import type {ReactElement, ReactNode} from 'react'
import {Children, cloneElement, isValidElement} from 'react'
import Link from 'next/link'
import Image from 'next/image'
import {loadImageFromKontentAI} from '@/image-loader'

interface CardProps {
	alt: string | null
	children?: ReactElement<{
		className: string
		children?: ReactNode
	}>
	className?: string
	imageUrl?: string
	src: string
	isFooterCardImage?: boolean
	openInNewTab?: boolean
}

export const CardImage = ({
	alt = '',
	children: child,
	className,
	imageUrl = '',
	src,
	isFooterCardImage,
	openInNewTab = false,
}: CardProps): ReactElement => {
	const classes = `shrink-0 ${className} ${
		isFooterCardImage ? 'w-full object-cover h-full' : 'w-full'
	}`
	const freshTab = openInNewTab
		? {target: '_blank', rel: 'noopener noreferrer'}
		: {target: '_self'}

	if (child && isValidElement(child)) {
		return cloneElement(child, {
			className: 'shrink-0',

			children: Children.map(
				child.props.children as ReactElement<{className: string}>,
				(el) => {
					if (el.type === 'img') {
						return cloneElement(el, {
							className: classes,
						})
					}
					return el
				}
			),
		})
	}
	return (
		<>
			{imageUrl.length ? (
				<Link className="relative z-30" href={imageUrl} {...freshTab}>
					<Image
						alt={alt || ''}
						className={classes}
						height={170}
						loader={loadImageFromKontentAI}
						src={src}
						width={330}
					/>
				</Link>
			) : (
				<Image
					alt={alt || ''}
					className={classes}
					height={170}
					loader={loadImageFromKontentAI}
					src={src}
					width={330}
				/>
			)}
		</>
	)
}
